// libraries
import { useEffect, useRef } from "react";
import videojs from "video.js";
import "videojs-contrib-eme";
import { GenericToastError } from "~/components/app-content/toast-error";
import { VideoJSErrorTypes } from "~/interfaces";

export const useInitializePlayer = (
    d_config: any,
    playerCallback?: (player: any) => void,
    closeCallback?: () => void,
    mediaType?: string
): React.RefObject<HTMLVideoElement> => {

    const videoRef = useRef<HTMLVideoElement | null>(null);
    const playerRef = useRef<any | null>(null);

    useEffect(() => {
        if (!playerRef.current && videoRef.current) {
            const player: any = videojs(videoRef.current, d_config, () => { });
            player.eme();
            playerRef.current = player;

            // Error listener
            player.on('error', () => {
                const error = player.error();
                if (error && closeCallback) {
                    closeCallback();
                    GenericToastError(getErrorMessage(error.code, mediaType), "Video Player");
                }
            });
        }

        if (playerCallback) {
            playerCallback(playerRef.current);
        }

        return () => {
            if (playerRef.current && !videoRef.current) {
              playerRef.current.dispose();
              playerRef.current = null; 
            }
          };
    }, [d_config, playerCallback]);

    return videoRef;
};


const getErrorMessage = (errorCode: number, mediaType: string | undefined): string => {
    switch(errorCode) {
        case VideoJSErrorTypes.MEDIA_ERR_ABORTED:
            return	"Video playback was aborted.";
        case VideoJSErrorTypes.MEDIA_ERR_CUSTOM:
            return	"Video playback failed for unknown reason.";
        case VideoJSErrorTypes.MEDIA_ERR_ENCRYPTED:
            return	"Secure video playback could not be established.";
        case VideoJSErrorTypes.MEDIA_ERR_NETWORK:
            return	"Video playback failed due to internet connectivity.";
        case VideoJSErrorTypes.MEDIA_ERR_SRC_NOT_SUPPORTED:
            return	`${mediaType ?? "Secure"} video playback unsupported on this device.`;
        default:
            return "Video playback failed for unknown reason.";
    }
};